import { z } from 'zod';
import {
    AutomaticMaterialPropertiesV1,
    AutomaticMaterialPropertiesSchemaV1,
    AutomaticMaterialWastePropertiesV1,
    AutomaticMaterialWastePropertiesSchemaV1,
} from './automatic-material-properties.ts';
import {
    AutomaticTransportPropertiesV1,
    AutomaticTransportPropertiesSchemaV1,
    AutomaticTransportNonHazardousWastePropertiesV1,
    AutomaticTransportNonHazardousWastePropertiesSchemaV1,
    AutomaticTransportHazardousWastePropertiesV1,
    AutomaticTransportHazardousWastePropertiesSchemaV1,
} from './automatic-transport-properties.ts';
import {
    ManualMaterialPropertiesSchemaV1,
    ManualMaterialPropertiesV1,
    ManualMaterialWastePropertiesSchemaV1,
    ManualMaterialWastePropertiesV1,
} from './manual-material-properties.ts';
import {
    ManualTransportPropertiesSchemaV1,
    ManualTransportPropertiesSchemaV2,
    ManualTransportPropertiesV1,
    ManualTransportPropertiesV2,
    ManualTransportWastePropertiesSchemaV1,
    ManualTransportWastePropertiesV1,
} from './manual-transport-properties.ts';
import { ManualServicePropertiesSchemaV1, ManualServicePropertiesV1 } from './manual-service-properties.ts';
import { AutomaticServicePropertiesSchemaV1, AutomaticServicePropertiesV1 } from './automatic-service-properties.ts';

export type AdditionalPropertyType =
    | AutomaticMaterialPropertiesV1
    | ManualMaterialPropertiesV1
    | AutomaticMaterialWastePropertiesV1
    | ManualMaterialWastePropertiesV1
    | AutomaticTransportPropertiesV1
    | ManualTransportPropertiesV1
    | ManualTransportPropertiesV2
    | AutomaticTransportHazardousWastePropertiesV1
    | AutomaticTransportNonHazardousWastePropertiesV1
    | ManualTransportWastePropertiesV1
    | ManualServicePropertiesV1
    | AutomaticServicePropertiesV1;

export const AdditionalPropertiesDiscriminatorSchema = z.discriminatedUnion('schemaId', [
    // Material
    AutomaticMaterialPropertiesSchemaV1,
    ManualMaterialPropertiesSchemaV1,
    // Material waste
    AutomaticMaterialWastePropertiesSchemaV1,
    ManualMaterialWastePropertiesSchemaV1,
    // Transport
    AutomaticTransportPropertiesSchemaV1,
    ManualTransportPropertiesSchemaV1,
    ManualTransportPropertiesSchemaV2,
    // Transport waste
    AutomaticTransportNonHazardousWastePropertiesSchemaV1,
    AutomaticTransportHazardousWastePropertiesSchemaV1,
    ManualTransportWastePropertiesSchemaV1,
    // Service
    ManualServicePropertiesSchemaV1,
    AutomaticServicePropertiesSchemaV1,
]);

export const AutomaticTransportPropertiesSchema = z.union([
    AutomaticTransportPropertiesSchemaV1,
    AutomaticTransportNonHazardousWastePropertiesSchemaV1,
    AutomaticTransportHazardousWastePropertiesSchemaV1,
]);

export type AutomaticTransportProperties = z.infer<typeof AutomaticTransportPropertiesSchema>;
